<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_9"></a><a id="ch01"></a><strong>Ancient Thera, Modern Teacher</strong></h2>
<p class="txt1">The wind working its</p>
<p class="txt2">way through ancient</p>
<p class="txt3">cracks and ill-fitting doors pestered</p>
<p class="txt4">me all night.</p>
<p class="txt1">Now it is morning and</p>
<p class="txt2">nothing has settled down the</p>
<p class="txt3">wind refuses to clear a space</p>
<p class="txt4">for contemplation. This is stormy</p>
<p class="txt1">country, lost to fire and sea, buried by meters and</p>
<p class="txt2">meters of hard pumice rain and heavy boulders,</p>
<p class="txt3">the volcano falling into its</p>
<p class="txt1">fiery heart and sea blazing in to fill the steaming</p>
<p class="txt2">crater that once was island.</p>
<p class="txt3">Gorgeous culture ended here.</p>
<p class="txt1">Island home to painters who knew</p>
<p class="txt2">no restraint who took ceremonial rooms and</p>
<p class="txt1">made them come alive with color and</p>
<p class="txt2">form bound by no convention</p>
<p class="txt3">strong joyful brush strokes bringing</p>
<p class="txt1"><a id="page_10"></a>life to barren walls on barren</p>
<p class="txt2">land their homes painted still today</p>
<p class="txt3">reminding us of times when</p>
<p class="txt1">dolphins danced with fleets and</p>
<p class="txt2">swallows swept the wild sea air</p>
<p class="txt3">with song. Even now when</p>
<p class="txt1">it all collapsed and 3500 years of</p>
<p class="txt2">grief and dust had to be gently cleansed</p>
<p class="txt3">to see their life even now Minoan joy</p>
<p class="txt1">is here and even now their happy</p>
<p class="txt2">life lifts my human heart above</p>
<p class="txt3">my own ruined time and</p>
<p class="txt1">reminds me that life can be</p>
<p class="txt2">good even when lived in the shadow of</p>
<p class="txt3">what must destroy it.</p>
<p class="txt1">They knew what was coming.</p>
<p class="txt1">Many times tremors and ash</p>
<p class="txt2">warned them to take their</p>
<p class="txt3">treasures and flee yet they</p>
<p class="txt4">returned to clean and</p>
<p class="txt1"><a id="page_11"></a>rebuild and recreate the life they loved</p>
<p class="txt1">and then the volcano would</p>
<p class="txt2">have no more of them and</p>
<p class="txt3">Earth erupted with the violence</p>
<p class="txt4">only found deep inside</p>
<p class="txt5">creation. All fire the</p>
<p class="txt1">blast blew black obsidian boulders like dust,</p>
<p class="txt2">mythic energy reminding humans</p>
<p class="txt3">how tenderly to walk</p>
<p class="txt4">the earth that goes from beloved</p>
<p class="txt5">to fire when it tolerates us</p>
<p class="txt1">no longer.</p>
<h3 class="h3"><strong>Thera, Greece, May 2004</strong></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?78716412